import { get } from 'lodash';

import { TAnalyticsEventSchema, TTrackerId } from '@shared/types';
import { setTagBeforeEventFiring } from '@shared/helpers';

import { store } from '@/redux/store/store';
import { pfbAnalyticsClient } from '@/data/analyticsClient';

import {
	getFingerprintCookie,
	getUserRoleNameByID,
	getUTMData,
} from './helper';
import Constants from './constants';
import tagsMapping from './tagsMapping';

type TTagMapping = typeof tagsMapping;

const getUserProfileInfoForEventTags = () => {
	const rootStore = store.getState();

	const userRolesList = get(rootStore, 'userProfile.userRolesList.data', []);
	const userRoleId = get(rootStore, 'userAuth.user.roleId', '');

	const selectedRole = getUserRoleNameByID(userRolesList, userRoleId);

	const merchantBusinessSuperCategory = get(
		rootStore,
		'merchantProfile.merchantDetails.superCategory',
		'NA',
	);
	const merchantBusinessCategory = get(
		rootStore,
		'merchantProfile.merchantDetails.category',
		merchantBusinessSuperCategory,
	);
	const merchantBusinessUnitType = get(
		rootStore,
		'merchantProfile.merchantDetails.businessUnit',
		'NA',
	);

	return {
		user_role: get(selectedRole, 'name', 'NA'),
		business_unit_type: merchantBusinessUnitType,
		business_category: merchantBusinessCategory,
	};
};

const setGarfieldConfigUpdateHandler = () => {
	pfbAnalyticsClient.updateGarfieldConfig({
		handleGarfieldEventData: (garfieldEvent) => {
			// Sending the global level tags such user_role, business_unit_type along with the local tags mapped to `data`
			const eventTags: Partial<Record<keyof TTagMapping, unknown>> = {
				...garfieldEvent.additionalData,
				...getUserProfileInfoForEventTags(),
				...getUTMData(),
			};

			// If we have an additional data, it will be formatted with delimiters ('|') and mapped into respective tags

			const extraData = setTagBeforeEventFiring(eventTags, tagsMapping);

			const garfieldEventObj = {
				...garfieldEvent,
				data: { tags: { ...extraData } },
			};
			return garfieldEventObj;
		},
	});
};

export const setAuthFlowGarfield = (isLoggedIn: boolean) => {
	pfbAnalyticsClient.updateGarfieldConfig({
		authFlow: {
			isLoggedIn,
			fingerprint: getFingerprintCookie(),
			version: Constants.BUILD_NUMBER,
		},
	});
};

export const sendEventToGarfield = (data: TAnalyticsEventSchema) => {
	pfbAnalyticsClient.sendGarfieldEvent(data);
};

export const initializeGarfieldWithTrackerID = (trackerId: TTrackerId) => {
	pfbAnalyticsClient.initGarfield({ trackerId });
	setGarfieldConfigUpdateHandler();
};
